{
    "coordinates": [
        46.9865471,
        -108.973861
    ],
    "tooltip": "Bear Gulch",
    "title": "Bear Gulch Limestone",
    "country": "United States",
    "period": "Carboniferous",
    "alt": "TODO"
}
